<template>
	<CImportFromJotformView
		:is-marketing-importer="true"
		@close="onClosed"
	/>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import CImportFromJotformView from 'src/components/navigation/new-form/ImportFromJotformView.vue';
	import session from '@cognitoforms/api/services/session';

	export default defineComponent({
		name: 'JotformImporter',
		components: {
			CImportFromJotformView
		},
		setup() {
			const onClosed = (): void => {
				window.location.assign(`/${session.value.orgCode}`);
			};

			return {
				onClosed
			};
		},
		head: {
			title: 'Import Your Jotform Account'
		}
	});
</script>
